import { render, staticRenderFns } from "./CampaignCandidate.vue?vue&type=template&id=848104f4&scoped=true"
import script from "./CampaignCandidate.vue?vue&type=script&lang=js"
export * from "./CampaignCandidate.vue?vue&type=script&lang=js"
import style0 from "./CampaignCandidate.vue?vue&type=style&index=0&id=848104f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848104f4",
  null
  
)

export default component.exports